import { Container } from 'react-bootstrap';
import { useDocumentTitle } from '../app/hooks/use-document-title';

export const RatingThankYouPage = () => {
  useDocumentTitle('Rating Accepted');
  return (
    <Container>
      <h1 className="text-center">Thank you for your rating!</h1>
    </Container>
  );
};
